type SocialMedia = {
    color: string, 
    svg: string,
    link: string,
}

export const socialMediaLinks: SocialMedia[] = [
    {
        color: '#1877f2',
        svg: '/icons/facebook.svg',
        link: 'https://www.facebook.com/',
    },
    {
        color: '#c32aa3',
        svg: '/icons/instagram.svg',
        link: 'https://www.instagram.com/',
    },
    {
        color: '#1da1f2',
        svg: '/icons/twitter.svg',
        link: 'https://twitter.com/',
    },
    {
        color: '#010101',
        svg: '/icons/tiktok.svg',
        link: 'https://www.tiktok.com/es/',
    },
];